/** The Backtest Club mark ("Rewind"), as inline SVG.
 *
 *  Inline rather than an <img src="/brand/logo.svg"> so it inherits the theme
 *  through `currentColor` — one component serves the light sidebar, the dark
 *  sidebar and any future placement without a second asset or a theme check in
 *  JS. The identical geometry ships as static files in `public/brand/` for
 *  everything outside React (favicon, manifest, OG image, app icons); both are
 *  generated from `brand/generate_assets.py`, so they cannot drift.
 *
 *  The mark: two chevrons travelling away from a vertical rule. Backtesting is
 *  not "play" — it runs history backwards from the present, and the rule is
 *  that present moment.
 */
export function LogoMark({
  size = 32,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Backtest Club"
    >
      {/* Structural chevron + present-moment rule follow the text colour. */}
      <path d="M30 11 L30 53 L4 32 Z" fill="currentColor" />
      <rect x="57" y="9" width="4" height="46" rx="2" fill="currentColor" />
      {/* Leading chevron carries the brand accent. */}
      <path d="M52 11 L52 53 L26 32 Z" className="fill-brand-600 dark:fill-brand-400" />
    </svg>
  );
}

/** Mark plus wordmark, for the sidebar and the login screen. */
export function LogoLockup({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={30} className="shrink-0 text-fg" />
      <span className="text-lg font-bold leading-none tracking-tight">
        <span className="text-fg">Backtest</span>
        <span className="font-light text-muted"> Club</span>
      </span>
    </div>
  );
}

export default LogoMark;
